import React, { useState } from "react";
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Stack,
  Typography,
} from "@mui/material";
import DefinicionVariable from "../../rangoPrecios/ActualizacionPrecio/DefinicionVariable";
import { UrlApi } from "../../../../services/apirest";
import moment from "moment";

function EdicionPrecioCategoria({ open, onClose, row }) {
  const [monto, setMonto] = useState("");
  const [porcentaje, setPorcentaje] = useState("");
  const [precioMinimo, setPrecioMinimo] = useState("");
  const [precioMaximo, setPrecioMaximo] = useState("");
  const [tipoOperacion, setTipoOperacion] = useState("");
  const [disBtn, setDisBtn] = useState(false);

  const [openSnack, setOpenSnack] = useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [exito, setExito] = useState(false);

  const handleClose = () => {
    if (onClose) onClose();
  };

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenSnack(false);
    if (exito) handleClose();
  };

  const validarInput = (value) => /^-?\d*\.?\d*$/.test(value);

  const handleMontoChange = (e) => {
    const value = e.target.value;
    if (validarInput(value)) {
      setMonto(value);
      if (value !== "") setPorcentaje("");
      setTipoOperacion("monto");
    }
  };

  const handlePorcentajeChange = (e) => {
    const value = e.target.value;
    if (validarInput(value)) {
      setPorcentaje(value);
      if (value !== "") setMonto("");
      setTipoOperacion("porcentaje");
    }
  };

  const handlePrecioMinimo = (e) => {
    const value = e.target.value;
    if (validarInput(value)) {
      setPrecioMinimo(value);
      if (value !== "") setMonto("");
      setTipoOperacion("precio");
    }
  };

  const handlePrecioMaximo = (e) => {
    const value = e.target.value;
    if (validarInput(value)) {
      setPrecioMaximo(value);
      if (value !== "") setMonto("");
      setTipoOperacion("precio");
    }
  };

  const handleActualizar = async (e) => {
    e.preventDefault();

    const valor = parseFloat(monto || porcentaje);
    let nuevoMin = Number(row.precio_minimo);
    let nuevoMax = Number(row.precio_maximo);

    if (tipoOperacion === "monto") {
      nuevoMin += valor;
      nuevoMax += valor;
    } else if (tipoOperacion === "porcentaje") {
      const factor = valor / 100;
      nuevoMin += nuevoMin * factor;
      nuevoMax += nuevoMax * factor;
    } else if (tipoOperacion === "precio") {
      nuevoMin = parseFloat(precioMinimo);
      nuevoMax = parseFloat(precioMaximo);
    } else {
      return;
    }

    nuevoMin = Math.round(nuevoMin);
    nuevoMax = Math.round(nuevoMax);

    if (isNaN(nuevoMin) || isNaN(nuevoMax)) {
      setExito(false);
      setColorMensaje("#F1948A");
      setMensaje("Ingrese una variación o un precio válido.");
      setOpenSnack(true);
      return;
    }
    if (nuevoMin > nuevoMax) {
      setExito(false);
      setColorMensaje("#F1948A");
      setMensaje("El precio mínimo no puede ser mayor al máximo.");
      setOpenSnack(true);
      return;
    }

    setDisBtn(true);
    try {
      const res = await fetch(
        UrlApi + "/envasado_rango_categorias/xID/" + row.id,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id_sucursal: row.id_sucursal,
            id_producto: row.id_producto,
            id_tipocliente: row.id_tipocliente,
            precio_minimo: nuevoMin,
            precio_maximo: nuevoMax,
            usuario: localStorage.getItem("user"),
          }),
        }
      );
      const data = await res.json();

      if (res.ok && data.message === "OK") {
        await fetch(UrlApi + "/envasado_historial_rango_categorias", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id_producto: row.id_producto,
            id_sucursal: row.id_sucursal,
            id_tipocliente: row.id_tipocliente,
            precio_minimo_anterior: Number(row.precio_minimo),
            precio_maximo_anterior: Number(row.precio_maximo),
            precio_minimo_nuevo: nuevoMin,
            precio_maximo_nuevo: nuevoMax,
            fecha: moment().format("YYYY-MM-DD"),
            usuario: localStorage.getItem("user"),
          }),
        });

        setExito(true);
        setColorMensaje("#D4EFDF");
        setMensaje("El precio se actualizó exitosamente !");
        setOpenSnack(true);
      } else {
        setExito(false);
        setColorMensaje("#F1948A");
        setMensaje(data.message || "Error al actualizar el precio.");
        setOpenSnack(true);
        setDisBtn(false);
      }
    } catch (err) {
      setExito(false);
      setColorMensaje("#F1948A");
      setMensaje("Error al conectar con la base de datos.");
      setOpenSnack(true);
      setDisBtn(false);
    }
  };

  return (
    <>
      <Dialog open={open} onClose={handleClose} maxWidth={"md"} fullWidth>
        <form
          onSubmit={handleActualizar}
          style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}
        >
          <Box bgcolor="#1F618D">
            <DialogTitle
              sx={{
                bgcolor: "#1F618D",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                p: 1,
              }}
            >
              <Typography
                variant="h6"
                component="div"
                sx={{ flexGrow: 1, textAlign: "center" }}
              >
                Actualizar Precio
              </Typography>
            </DialogTitle>
          </Box>
          <DialogContent sx={{ p: 1.8 }}>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
              {row.nombre_sucursal} · {row.nombre_producto} ·{" "}
              {row.nombre_tipocliente}
            </Typography>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
              Actual: mín ${row.precio_minimo} — máx ${row.precio_maximo}
            </Typography>
            <DefinicionVariable
              monto={monto}
              porcentaje={porcentaje}
              precioMinimo={precioMinimo}
              precioMaximo={precioMaximo}
              handleMontoChange={handleMontoChange}
              handlePorcentajeChange={handlePorcentajeChange}
              handlePrecioMinimo={handlePrecioMinimo}
              handlePrecioMaximo={handlePrecioMaximo}
            />
          </DialogContent>
          <DialogActions
            sx={{ justifyContent: "space-between", p: 1 }}
          >
            <Button
              color="error"
              variant="contained"
              onClick={handleClose}
              sx={{ minWidth: 120 }}
            >
              Volver
            </Button>
            <Button
              color="success"
              type="submit"
              variant="contained"
              sx={{ minWidth: 120 }}
              disabled={disBtn}
            >
              Confirmar
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity={exito ? "success" : "error"}
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default EdicionPrecioCategoria;
